import React from "react";
import { Box, TextField, Button, Chip } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";

const getStatusColor = (status) => {
  const statusColors = {
    "Em aberto": "#f39c12",
    Atendido: "#27ae60",
    Cancelado: "#e74c3c",
    "Em andamento": "#3498db",
  };
  return statusColors[status] || "#95a5a6";
};

export default function PurchaseOrderFilters({
  searchTerm,
  onSearchChange,
  filterStatus,
  onFilterChange,
  uniqueStatuses,
  createdAtInicio,
  setCreatedAtInicio,
  createdAtFim,
  setCreatedAtFim,
  onSearch,
  onClearFilters,
}) {
  const handleClearFilters = () => {
    if (onClearFilters) {
      onClearFilters();
    } else {
      onFilterChange("todos");
      onSearchChange("");
      setCreatedAtInicio(null);
      setCreatedAtFim(null);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ p: 3, bgcolor: "#f5f5f5", borderTop: "1px solid #e0e0e0" }}>
        {/* Linha de filtros */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            alignItems: "center",
            mb: 2,
            flexWrap: "wrap",
          }}
        >
          <TextField
            placeholder="Buscar por fornecedor, número ou email..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            size="small"
            sx={{ minWidth: 300 }}
            InputProps={{
              startAdornment: (
                <SearchIcon sx={{ color: "text.secondary", mr: 1 }} />
              ),
            }}
          />

          <DatePicker
            label="Data Inicial"
            value={createdAtInicio}
            onChange={(newValue) => setCreatedAtInicio(newValue)}
            slotProps={{ textField: { size: "small" } }}
            format="DD/MM/YYYY"
          />

          <DatePicker
            label="Data Final"
            value={createdAtFim}
            onChange={(newValue) => setCreatedAtFim(newValue)}
            slotProps={{ textField: { size: "small" } }}
            format="DD/MM/YYYY"
          />

          <Button
            variant="contained"
            size="small"
            startIcon={<SearchIcon />}
            onClick={onSearch}
            sx={{
              bgcolor: "#2196f3",
              "&:hover": { bgcolor: "#1976d2" },
            }}
          >
            Buscar
          </Button>

          <Button
            variant="outlined"
            size="small"
            startIcon={<FilterListIcon />}
            onClick={handleClearFilters}
            sx={{
              borderColor: "#ff9800",
              color: "#ff9800",
              "&:hover": { borderColor: "#f57c00", bgcolor: "#fff3e0" },
            }}
          >
            Limpar Filtros
          </Button>
        </Box>

        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
          {uniqueStatuses.map((status) => (
            <Chip
              key={status}
              label={status === "todos" ? "Todos" : status}
              onClick={() => onFilterChange(status)}
              variant={filterStatus === status ? "filled" : "outlined"}
              sx={{
                ...(filterStatus === status
                  ? {
                      bgcolor:
                        status === "todos" ? "#ff9800" : getStatusColor(status),
                      color: "white",
                      "&:hover": { opacity: 0.9 },
                    }
                  : {
                      borderColor: "#e0e0e0",
                      "&:hover": { bgcolor: "#f0f0f0" },
                    }),
              }}
            />
          ))}
        </Box>
      </Box>
    </LocalizationProvider>
  );
}
